import React from 'react';
import DOMPurify from 'dompurify';
import { IonCard, IonCardContent, IonText } from '@ionic/react';

import Price from '../Price';

import './promotion-posts.css';

// Card di una promozione: immagine quadrata, titolo, descrizione e prezzi
const PostCard = ({ post }) => {
  const listPrice = Number(post.list_price) || 0;
  const promoPrice = Number(post.promo_price) || 0;
  // Prezzo mostrato: promo, altrimenti listino; nullo o 0 = non mostrato
  const price = promoPrice > 0 ? promoPrice : listPrice;
  const discount = listPrice > price ? Math.round(((listPrice - price) / listPrice) * 100) : 0;

  return (
    <IonCard className="promotion-post-card">
      {post.image_url && <img className="promotion-post-image" src={post.image_url} alt={post.title} />}

      <IonCardContent>
        <h3 className="promotion-post-title">{post.title}</h3>

        {post.description && (
          <div
            className="promotion-post-description"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.description) }}
          />
        )}

        {price > 0 && (
          <p className="promotion-post-prices">
            <IonText color="success">
              <b>
                <Price price={price} />€
              </b>
            </IonText>
            {listPrice > price && (
              <>
                &nbsp;
                <span className="promotion-post-list-price">
                  <Price price={listPrice} />€
                </span>
                <IonText color="danger">
                  &nbsp; -{discount}%
                </IonText>
              </>
            )}
          </p>
        )}

        {post.ends_at && (
          <p className="promotion-post-validity">
            Valida fino al {new Date(post.ends_at).toLocaleDateString('it-IT')}
          </p>
        )}
      </IonCardContent>
    </IonCard>
  );
};

export default PostCard;
